export const ADVANCED_PAGE_WIDTH = 1500;
export const ADVANCED_PAGE_SECTION_GAP = 16;
export const ADVANCED_PAGE_BOTTOM_PADDING = 40;
export const ADVANCED_RAIL_WIDTH = 300;
export const ADVANCED_RAIL_STICKY_TOP = 108;
export const ADVANCED_COLUMN_GAP = 16;
export const FEATURE_ROWS_GAP = 14;

export const ADVANCED_SEARCH_SECTION_ID = "USER_ADVANCED_SEARCH";

export const ADVANCED_SECTION_IDS = {
  PROFILE: "USER_ADVANCED_PROFILE",
  MODERATION: "USER_ADVANCED_MODERATION",
  IDENTITY: "USER_ADVANCED_IDENTITY",
  COMMENTS: "USER_ADVANCED_COMMENTS",
  SUBSCRIPTIONS: "USER_ADVANCED_SUBSCRIPTIONS",
  DESCRIPTIONS: "USER_ADVANCED_DESCRIPTIONS",
  VERIFICATION: "USER_ADVANCED_VERIFICATION",
  DEVICE: "USER_ADVANCED_DEVICE",
  ACTIONS: "USER_ADVANCED_ACTIONS"
};
